module.exports = __webpack_public_path__ + "media/images/icons/ic-filter-8cb20d3b3e8040046cb2f8ffcf391f83.svg";